import * as types from '@/store/mutations'
import api from '@/services/parties'
import moment from 'moment'

const getters = {
  parties: (state)=> state.parties,

  orderParties: (state)=>{
    if(state.openOrder !== null){
      let nonDealerParties = state.openOrder.order.parties?.filter(p => !p.isDealerParty).sort((a, b) =>{moment(a.date.date).isBefore(moment(b.date.date))})
      if (nonDealerParties !== undefined){
        if(nonDealerParties.length > 0){
          let partiesByDay = new Map()
          nonDealerParties.map((party)=>{
            if(!partiesByDay.has(moment(party.date.date).dayOfYear()) ){
              partiesByDay.set(moment(party.date.date).dayOfYear(), {date:party.date.date, parties:[]})
            }
            let ref = partiesByDay.get(moment(party.date.date).dayOfYear())
            
            ref.parties.push(party)
          })
          return Array.from(partiesByDay.values())
        }
        return []
      }
      return []
    }
    return []
  },

  getCalendarParties: (state) =>{
    return state.calendarDates
  },
  
  getActiveParty: (state) => state.activeParty,
  getOpenOrder:(state)=> state.openOrder,
  getDealerParty:(state)=>{
    if(state.openOrder !== null){
      let dealerparties = state.openOrder.order.parties.filter(p => p.isDealerParty)
      if(dealerparties.length > 0){
        return dealerparties[0]
      }
    }
    return null
  },
  
  getFilteredOrders: (state) => (filtered) => {
    if(filtered.length > 2){
      return state.orderHistory.sort((a,b)=>{return b.id - a.id}).filter((order) => {
        return order.orderno.toString().indexOf(filtered.toUpperCase()) >= 0
      })
    }
    return state.orderHistory.sort((a,b)=>{return b.id - a.id})
  },
  
  getFilteredInvoices: (state) => (filtered) => {
    if(filtered.length > 2){
      return state.invoiceHistory.sort((a,b)=>{return b.invoicenumber - a.invoicenumber}).filter((invoice) => {
        return invoice.invoicenumber.toString().indexOf(filtered.toUpperCase()) >= 0
      })
    }
    return state.invoiceHistory.sort((a,b)=>{return b.invoicenumber - a.invoicenumber})
  },

  getOpenOrderCustlist: (state)=> {
    let ret = new Map()

    if(state.openOrder !== null){
      state.openOrder.parties.map((party)=>{
        party.customerOrders.map((custlist)=>{
          custlist.lines.map((line)=>{
            if(!ret.has(line.productId)){
              ret.set(line.productId,{
                id:-1,
                productTypeId:line.productTypeId,
                productId:line.productId,
                quantity:line.quantity,
                pricePrProduct:line.pricePrProduct,
              })
            }else{
              let existing = ret.get(line.productId)
              ret.set(line.productId,{
                id:-1,
                productId:line.productId,
                productTypeId:line.productTypeId,
                quantity:existing.quantity + line.quantity,
                pricePrProduct:line.pricePrProduct
              })

            }

          })
        })
      })
    }
    let returnObj = {
      processStatus:{
        statusid:3
      },
      lines:Array.from(ret.values()),
    }
    return returnObj
  },
  
  getOpenOrderProducts: (state) =>{
    let ret = []
    if(state.openOrder !== null){
      state.openOrder.parties.map((party)=>{
        party.customerOrders.map((custlist)=>{
          custlist.lines.map((line)=>{
            if(ret.filter((elem)=>{return elem == line.productId}).length == 0){
              ret.push(line.productId)

            }

          })
        })
      })
    }


    return ret

  },
  
  getParty:(state) => (id) => {
    if(!parseInt(id)){
      return null
    }

    if(state.parties.length == 0){
      return null
    }

    let parties = state.parties.filter(party => { return parseInt(id) === parseInt(party.id) })
    if(parties.length > 0){
      let party = Object.assign({}, parties[0])
      return party
    }

    return null
  },
  
  getPartyTotalItems: (state) => () => {
    let ret = 0
    if(state.activeParty === null){
      return 0
    }

    state.activeParty.customerOrders.map(el =>{
      el.lines.map(line =>{
        ret += parseInt(line.quantity)
      })
    })
    return ret
  },
  
  getActivePartySum: (state) => () =>{
    if(state.activeParty === null){
      return 0
    }
    return state.activeParty.partySale
  },
  
  getActivePartyDiscount: (state) => () =>{
    if(state.activeParty === null){
      return 0
    }
    let discount = state.dealer?.discount ?? 0
    return parseInt(state.activeParty.partySale) * discount / 100
  },
  
  getReservationState: (state) => () =>{
    if(state.reservationStatus === "open"){
      return "open";
    }
    return "reserved";
  }

}

const actions = {
  addParty(context, payload) {
    return new Promise((resolve, reject)=>{
      api.addParty(payload).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  submitParty(context, payload) {
    return new Promise((resolve, reject)=>{
      api.submitParty(payload).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  deleteParty(context, payload) {
    return new Promise((resolve, reject)=>{
      api.deleteParty(payload).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  resendDiscountEmail(context, payload) {
    return new Promise((resolve, reject)=>{
      api.resendDiscountEmail(payload).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  saveParty(context, {id, payload} ) {
    return new Promise((resolve, reject)=>{
      api.saveParty(payload, id).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  
  async deleteCustlist(store, custlistId){
    return api.deleteCustlist(custlistId)
  },
  
  toggleDirectDelivery(context, payload ) {
    return new Promise((resolve, reject)=>{
      let req = {
        isDirectDelivery:payload.isDirectDelivery
      }
      api.setDirectDeliveryParty(payload.id,req).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },

  toggleHold(context, payload ) {
    return new Promise((resolve, reject)=>{
      api.togglePartyHold(payload.id).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },

  toggleCustDirectDelivery(context, payload ) {
    return new Promise((resolve, reject)=>{
      let req = {
        isDirectDelivery:payload.isDirectDelivery
      }
      api.setDirectDeliveryCustomer(payload.id,req).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },

  addParticipant(store, payload ) {
    return new Promise((resolve, reject)=>{
      let req = {
        personId:payload.personId,
        partyId:payload.partyId
      }
      api.addParticipant(req).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  
  addFocusProduct(store, payload ) {
    return new Promise((resolve, reject)=>{
      let req = {
        sku:payload.sku,
        partyId:payload.partyId,
        price:payload.price
      }
      api.addFocusProduct(req).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  
  removeFocusProduct(store, payload ) {
    return new Promise((resolve, reject)=>{
      let req = {
        sku:payload.sku,
        partyId:payload.partyId,
      }
      api.removeFocusProduct(req).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  
  moveParticipant(store, payload) {
    return new Promise((resolve, reject)=>{
      let req = {
        custListId:payload.custListId,
        partyId:payload.partyId
      }
      api.moveParticipant(req).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },

  /* personId as variable name here is completely wrond. It's webOrderCustomerId - but I don't dare change it right now //HFA/12/9-23 */
  addProductToWoc({ commit }, { personId, sku, line_type }) {
    commit(types.START_UPDATING_CART_QUANTITY, sku)
    return new Promise((resolve, reject)=>{
      api.addProductToWoc({ personId, sku, line_type}).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      }).finally(() => {
        commit(types.DONE_UPDATING_CART_QUANTITY, sku)
      })
    })
  },
  
  removeProductFromWoc({ commit }, { personId, sku, line_type }) {
    commit(types.START_UPDATING_CART_QUANTITY, sku)

    return new Promise((resolve, reject)=>{
      api.removeProductFromWoc({ personId, sku, line_type }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      }).finally(() => {
        commit(types.DONE_UPDATING_CART_QUANTITY, sku)
      })
    })
  },
  
  makeReservation(context, { custId, lineId }) {
    //        commit(types.START_UPDATING_CART_QUANTITY, sku)

    return new Promise((resolve, reject)=>{
      api.reserveLine({ custId, lineId }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      }).finally(() => {
        //          commit(types.DONE_UPDATING_CART_QUANTITY, sku)
      })
    })
  },
  
  releaseReservation(context, { custId, lineId }) {
    //      commit(types.START_UPDATING_CART_QUANTITY, sku)
    return new Promise((resolve, reject)=>{
      api.releaseReservedLine({ custId, lineId }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      }).finally(() => {
        //        commit(types.DONE_UPDATING_CART_QUANTITY, sku)
      })
    })
  },
  
  makeBackorder(context, { custId, lineId }) {
    //        commit(types.START_UPDATING_CART_QUANTITY, sku)
    return new Promise((resolve, reject)=>{
      api.backorderLine({ custId, lineId }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      }).finally(() => {
        //          commit(types.DONE_UPDATING_CART_QUANTITY, sku)
      })
    })
  },
  
  cancelBackorder(context, { custId, lineId }) {
    //      commit(types.START_UPDATING_CART_QUANTITY, sku)
    return new Promise((resolve, reject)=>{
      api.cancelBackorderedLine({ custId, lineId }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      }).finally(() => {
        //        commit(types.DONE_UPDATING_CART_QUANTITY, sku)
      })
    })
  },
  
  makeReturn(context, { custId, lineId }) {
    //        commit(types.START_UPDATING_CART_QUANTITY, sku)
    return new Promise((resolve, reject)=>{
      api.returnLine({ custId, lineId }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      }).finally(() => {
        //          commit(types.DONE_UPDATING_CART_QUANTITY, sku)
      })
    })
  },
  
  cancelReturn(context, { custId, lineId }) {
    //      commit(types.START_UPDATING_CART_QUANTITY, sku)    
    return new Promise((resolve, reject)=>{
      api.cancelReturnedLine({ custId, lineId }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      }).finally(() => {
        //        commit(types.DONE_UPDATING_CART_QUANTITY, sku)
      })
    })
  },

  loadParty({commit}, payload ) {
    return new Promise((resolve, reject)=>{
      api.loadParty(payload).then((res)=>{        
        commit(types.SET_ACTIVE_PARTY, res)        
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },

  loadOpenOrder({commit}){
    return new Promise((resolve, reject)=>{
      api.openOrder().then((res)=>{
        commit(types.SET_OPEN_ORDER, res)
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },

  loadDealersCustlist({commit}){
    return new Promise((resolve, reject)=>{
      api.dealersCustlist().then((res)=>{
        commit(types.SET_DEALERS_CUSTLIST, res)
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },

  loadOrderById(context, payload){
    return new Promise((resolve, reject)=>{
      api.loadOrderById(payload).then((res)=>{
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },

  loadAllOrders({commit}){
    return new Promise((resolve, reject)=>{
      api.orderHistory().then((res)=>{
        commit(types.SET_ORDERS,res)
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  
  loadAllInvoices({commit}){
    return new Promise((resolve, reject)=>{
      api.invoiceHistory().then((res)=>{
        commit(types.SET_INVOICES, res)
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  loadDealerInvoices(context, payload){
    return new Promise((resolve, reject)=>{
      api.dealerInvoices(payload).then((res)=>{

        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  handInOrder({commit}, payload){
    return new Promise((resolve, reject)=>{
      api.handInOrder(payload).then((res)=>{
        commit(types.SET_OPEN_ORDER, res.newOrder)
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  
  getCalendar({commit}){
    return new Promise((resolve, reject)=>{
      api.getCalendar().then((res)=>{
        commit(types.SET_PARTIES,res.partiesByDay)
        resolve(1)
      }).catch((e)=>{
        reject(e)
      })
      
      
    })
  },
  
  getCalendarRange({commit}, payload){
    return new Promise((resolve, reject)=>{
      api.getCalendarRange(payload).then((res)=>{
        commit(types.SET_CALENDAR_DATES,res.partiesByDay)
        resolve(res)
      }).catch((e)=>{
        reject(e)
      })
      
      
    })
  },
}

const mutations = {
  [types.SET_PARTIES](state, parties) {
    state.parties = parties
  },
  [types.SET_ORDERS](state, orders) {
    state.orderHistory = orders
  },
  [types.SET_INVOICES](state, invoices) {
    state.invoiceHistory = invoices
  },
  [types.SET_CALENDAR_DATES](state, calendarDates) {
    state.calendarDates = calendarDates
  },
  [types.SET_ACTIVE_PARTY](state, party) {
    state.activeParty = party
  },
  [types.SET_OPEN_ORDER](state,order){
    state.openOrder = order
  },
  [types.SET_DEALERS_CUSTLIST](state,custlist){
    state.dealersCustlist = custlist
  },

  [types.REPLACE_PARTY](state, payload){
    let foundIndex = state.parties.findIndex((item)=>{
      item.id === payload.id
    })
    if(foundIndex){
      let parties = [...state.parties]
      parties[foundIndex] = payload
      state.parties = parties
    } else{
      state.parties.push(payload)
    }

  },
  [types.START_UPDATING_CART_QUANTITY](state, sku){
    state.updatingSKUCartQuantities[sku] = true
  },
  [types.DONE_UPDATING_CART_QUANTITY](state, sku){
    state.updatingSKUCartQuantities[sku] = false
  },
  [types.START_ADDING_PARTICIPANT](state, userId){
    state.addingParticipants[userId] = true
  },
  [types.DONE_ADDING_PARTICIPANT](state, userId){
    state.addingParticipants[userId] = false
  }
}

const state = {
  parties: [],
  calendarDates:[],
  activeParty: null,
  openOrder: null,
  activeOrder:null,
  invoiceHistory:[],
  orderHistory:[],
  updatingSKUCartQuantities: {},
  addingParticipants: {},
  dealersCustlist:null
  
}

export default {
  state,
  getters,
  actions,
  mutations
}
